import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from '../performanceEndpoints';

const AnnualizedTable = ({ className }) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsAnnualizedPerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceAnnualizedFootnote')}
      wrapperId="annualizedWrapper"
      tableId="annualizedTable"
      endpoint={endpoints.ANNUALIZED}
      className={className}
    />
  );
};

export default AnnualizedTable;
